<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader && model) {
    <div class="detail-page-action-bar flex-action-bar">
        <div>
            @if (permissions.CanEdit) {
                <button
                    class="btn btn-cerrix"
                    (click)="save()"
                    [disabled]="
                        !mainComponent ||
                        !mainComponent.simpleTestingGroup ||
                        !mainComponent.simpleTestingGroup.valid
                    "
                >
                    <i class="fas fa-save"></i>
                    <span class="d-none d-lg-inline">{{
                        (isDesignImplementation
                            ? 'simpleTestingDetail.saveButtonDi'
                            : 'simpleTestingDetail.saveButtonEff'
                        ) | t
                    }}</span>
                </button>
            } @else if (permissions.CanUploadEvidence) {
                <button class="btn btn-cerrix" (click)="uploadEvidence()">
                    <i class="fas fa-save"></i>
                    <span class="d-none d-lg-inline">{{ 'simpleTestingDetail.uploadEvidenceBtn' | t }}</span>
                </button>
            }

            <span class="date-edited">
                @if (model.Version === 0) {
                    <span>{{
                        (isDesignImplementation
                            ? 'simpleTestingDetail.initialVersionDi'
                            : 'simpleTestingDetail.initialVersionEff'
                        ) | t
                    }}</span>
                } @else if (model.Version > 0) {
                    <span
                        >Version <b>{{ model.Version }}</b> saved on
                        <b>{{ model.DateEdited | dateTimeFormat }}</b></span
                    >
                }
            </span>
        </div>

        @if (model.Workflow) {
            <div class="workflow-area">
                <span class="workflow-description">
                    {{ 'simpleTestingDetail.workflowStatusLabel' | t }} |
                    <b>{{ model.Workflow.Status }}</b>
                    @if (model.Workflow.Tooltip) {
                        <i
                            class="ms-2 fas fa-question-circle"
                            [matTooltip]="model.Workflow.Tooltip"
                        ></i>
                    }
                </span>
                @for (btn of model.Workflow.Buttons; track btn) {
                    <button
                        (click)="doAction(btn)"
                        class="btn btn-{{ btn.ButtonClass ? btn.ButtonClass : 'dark' }}"
                        [matTooltip]="btn.Tooltip"
                    >
                        @if (btn.Icon) {
                            <i [class]="btn.Icon + ' me-2'"></i>
                        }
                        {{ btn.Text }}
                    </button>
                }
            </div>
        }
    </div>

    <div menuSystem [cerrixTab]="tab" (changeEvent)="handleMenuItemClick($event)">
        <div
            class="control-screens"
            [attr.name]="
                (isDesignImplementation
                    ? 'simpleTestingDetail.typeDescDi'
                    : 'simpleTestingDetail.typeDescEff'
                ) | t
            "
            [attr.menuItemID]="typeDesc"
            menuicon="fas fa-book"
            menusystemsubmenu
        >
            <div [attr.name]="'simpleTestingDetail.menuDetails' | t" menuItemId="Details" menuicon="fas fa-info-circle" menusystemitem>
                <simple-testing-main
                    [model]="model"
                    [type]="type"
                    [typeDesc]="typeDesc"
                    [testScoreConfig]="testScoreConfig"
                    [permissions]="permissions"
                    #mainComponent
                >
                </simple-testing-main>
            </div>

            @if (model.Version > 0) {
                @if (permissions.CanViewEvidence) {
                    <div
                        [attr.name]="'simpleTestingDetail.menuEvidence' | t"
                        menuItemId="evidenceTab"
                        menuicon="fas fa-vials"
                        menusystemitem
                    >
                        @if (model.UploaderEvidenceLoaded) {
                            <document-manager-old
                                [(Documents)]="model.Documents"
                                [Label]="
                                    'simpleTestingDetail.uploaderEvidenceTitle' | t
                                "
                                [AllowAdd]="permissions.CanUploadEvidence"
                                [AllowEdit]="permissions.CanUploadEvidence"
                                [AllowDelete]="permissions.CanUploadEvidence"
                                [DocumentTypeTargets]="documentTypeTargets"
                                #evidenceComponent
                            ></document-manager-old>
                        } @else {
                            <div class="detail-page-card">
                                <div class="detail-page-card-title">{{ 'simpleTestingDetail.uploaderEvidenceTitle' | t }}</div>
                                <div class="detail-page-card-body padded cerrix-control-sm">
                                    <div class="fancy-loader submodule"></div>
                                </div>
                            </div>
                        }
                    </div>
                }

                <div
                    [attr.name]="'simpleTestingDetail.menuHyperlinks' | t"
                    [attr.menuItemID]="hyperlinksMenuItemId"
                    menuicon="fas fa-external-link-alt"
                    menusystemitem
                >
                    @if (model.Hyperlinks) {
                        <div>
                            <hyperlink-manager
                                [Hyperlinks]="model.Hyperlinks"
                                (HyperlinksChanged)="checkHyperlinksDirty()"
                                [TargetModule]="targetModule"
                            ></hyperlink-manager>
                        </div>
                    } @else {
                        <div>
                            <div class="fancy-loader"></div>
                        </div>
                    }
                </div>
            }

            <div [attr.name]="'simpleTestingDetail.menuHistory' | t" menuItemId="historyTab" menuicon="fas fa-history" menusystemitem>
                <app-history-overview
                    [historyDataService]="ds"
                    [Id]="id"
                    [ExtraParam]="type"
                    [label]="'simpleTestingDetail.menuHistory' | t"
                    #historyOverviewComponent
                >
                </app-history-overview>
            </div>
        </div>
    </div>
}
<div class="modal fade" bsModal #modal="bs-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-events-name" class="modal-title pull-left">
                    {{ 'simpleTestingDetail.testDetailOfVersion' | t: { version: testPlanByScoreVersion } }}
                </h4>
                <button
                    type="button"
                    class="btn-close pull-right"
                    [attr.aria-label]="'simpleTestingDetail.closeAriaLabel' | t"
                    (click)="modal.hide()"
                ></button>
            </div>
            <div class="modal-body">
                <simple-testing-testplan
                    [guid]="id"
                    [type]="type"
                    #testplanByVersion
                ></simple-testing-testplan>
            </div>
        </div>
    </div>
</div>
